import React from "react";
import { Link } from "react-router-dom";

import { plural } from "utils/strings";
import { IconButton } from "components";
import { Role } from "utils";

const ViewCareCirclesButton = ({ user = {}, tableType }) => {
  const canSeeCareCircles = () => {
    if (user?.numbersOfCircles <= 0) return false;
    if (Role.adminAccess()) return true;

    if (Role.careHomeAccess()) {
      // TODO use userTableTypes from constants
      if (tableType === "users") return true;
      if (tableType === "caregivers") return true;
    }
    if (
      Role.caregiverAccess() &&
      tableType === "users" &&
      user?.type === "thriver"
    ) {
      return true;
    }
    return false;
  };

  return canSeeCareCircles() ? (
    <div>
      <Link
        to={{
          pathname: "/care-circles",
          state: {
            search: Role.adminAccess() ? user.identifier : user.email,
          },
        }}
        style={{ width: "auto" }}
      >
        <IconButton
          icon="cil-circle"
          name={`View care ${plural("circle", user?.numbersOfCircles)}`}
        />
      </Link>
    </div>
  ) : null;
};

export default ViewCareCirclesButton;
